import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_279_53790)">
      <path d="M0.75 3.74609H13.25" stroke="#070F21" strokeLinecap="round" />
      <path
        d="M11.4909 3.74609H2.5053C2.36025 6.36863 2.36251 8.97094 2.75342 11.577C2.89774 12.5391 3.72423 13.2509 4.69711 13.2509H9.29911C10.272 13.2509 11.0984 12.5391 11.2428 11.577C11.6337 8.97094 11.6359 6.36863 11.4909 3.74609Z"
        fill="white"
        stroke="#070F21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.50195 3.74521V3.24601C4.50195 2.58402 4.76492 1.94916 5.23302 1.48106C5.70111 1.01297 6.33598 0.75 6.99796 0.75C7.65994 0.75 8.29481 1.01297 8.7629 1.48106C9.23099 1.94916 9.49397 2.58402 9.49397 3.24601V3.74521"
        stroke="#070F21"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.50049 6.41797V10.5558" stroke="#070F21" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.49561 6.41797V10.5558" stroke="#070F21" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_279_53790">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const DeleteBrand = memo(ForwardRef);
export default DeleteBrand;
